import React, { useEffect, useState } from 'react';

import { headersCotacao, valoresExibidosCotacao } from './auxiliarCotacao';
import BarraInferiorBotoes from '../../../../../../../components/BarraInferiorBotoes';
import BoxConteudo from '../../../../../../../components/BoxConteudo';
import CustomButton from '../../../../../../../components/CustomButton';
import CustomCol from '../../../../../../../components/CustomCol';
import CustomRow from '../../../../../../../components/CustomRow';
import Input from '../../../../../../../components/InputNew';
import Select from '../../../../../../../components/InputNew/Select';
import Log from '../../../../../../../components/Log/Log';
import Modal from '../../../../../../../components/Modal';
import Tabela from '../../../../../../../components/Tabela';
import WorkspaceBotoes from '../../../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../../../components/WorkspaceFicha';
import { useStatusCotacao } from '../../../../../../../services/enum/useStatusCotacao';
import httpClient, {
  isHttpError,
} from '../../../../../../../services/httpClient';
import { getCotacaoPorOrgInter } from '../../../../../../../services/orgInters/orgInterCotacaoService';
import { getProdutoPorPlanoTrabalho } from '../../../../../../../services/orgInters/orgInterPlanoTrabalhoService';
import theme from '../../../../../../../theme';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatarValorFormatoDinheiro,
  formatDate,
  formatDateSimp,
  formatoMoney,
  parseInputMonetario,
} from '../../../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../../../utils/swal';
import { useOrgInterDadosGerais } from '../../context/dadosGeraisContext';

interface Props {
  termoRefId: number;
}

type CotacaoType = {
  id: number;
  usuarioId: number;
  orgInterId: number;
  termoRefId: number;
  produtoId: number;
  statusCotacao: number;
  numeracaoReq: string;
  qtdCotada: string;
  cotacaoDolar: string;
  valorUnitario: string;
  valorTotal: string;
  dataSolicitacao: string;
  dataCotacao: string;
  observacoes: string;
};

const ItemCotacao: React.FC<Props> = ({ termoRefId }) => {
  const { componente, orgInter, userID } = useOrgInterDadosGerais();
  //////STATES
  const [logData, setLogData] = useState<any>();
  const [showModal, setShowModal] = useState(false);
  const [cotacaoId, setCotacaoId] = useState('');
  const [updatingCotacao, setUpdatingCotacao] = useState(false);
  const statusCotacaoOptions = useStatusCotacao();

  const [data, setData] = useState<any[]>();
  const [formCotacao, setFormCotacao] = useState<CotacaoType>({
    id: 0,
    usuarioId: userID,
    orgInterId: orgInter,
    termoRefId: termoRefId,
    statusCotacao: 0,
    produtoId: 0,
    numeracaoReq: '',
    qtdCotada: '',
    cotacaoDolar: '',
    valorUnitario: '',
    valorTotal: '',
    dataSolicitacao: '',
    dataCotacao: '',
    observacoes: '',
  });

  //////FETCH DATA
  const [produtoData, setProdutoData] = useState<
    { value: number; label: string }[]
  >([]);
  const fetchProdutos = async () => {
    try {
      const produtos = await getProdutoPorPlanoTrabalho(String(orgInter));

      setProdutoData([
        { value: 0, label: 'Não informado' },
        ...produtos.map(
          (item: { id: number; produtoFarmaceutico: string }) => ({
            value: item.id,
            label: item.produtoFarmaceutico,
          }),
        ),
      ]);
    } catch (error) {
      console.error('Erro ao obter produtos:', error);
      setProdutoData([]);
    }
  };

  useEffect(() => {
    fetchProdutos();
  }, []);

  const fetchCotacoes = async () => {
    try {
      const cotacoes = await getCotacaoPorOrgInter(String(orgInter));
      setData(cotacoes);
    } catch (error) {
      console.error('Erro ao obter dados', error);
    }
  };
  useEffect(() => {
    fetchCotacoes();
  }, []);

  //////TABLE E OFFCANVAS
  const tableData =
    data
      ?.slice() // faz uma cópia para não mutar o array original
      .sort(
        (a, b) =>
          new Date(a.dataInicio).getTime() - new Date(b.dataInicio).getTime(),
      )
      .map((item) => {
        // Definindo cores de fundo com base no status do documento
        let statusBackgroundColor = '';
        let colorText = 'black';

        const statusLabel = statusCotacaoOptions[item.statusCotacao].label;

        if (statusLabel === 'Aguardando Cotação') {
          statusBackgroundColor = theme.colors.amarelogov;
          colorText = 'white';
        } else if (statusLabel === 'Cotado') {
          statusBackgroundColor = theme.colors.verdegov;
          colorText = 'white';
        } else if (statusLabel === 'Suspenso') {
          statusBackgroundColor = theme.colors.laranja;
          colorText = 'white';
        } else if (statusLabel === 'Cancelado') {
          statusBackgroundColor = theme.colors.vermelho;
          colorText = 'white';
        }

        return {
          id: item.id,
          statusCotacao: (
            <span
              style={{
                backgroundColor: statusBackgroundColor,
                color: colorText,
                borderRadius: '10px',
                padding: '12px',
                display: 'inline-block',
                minWidth: '100px',
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {statusLabel}
            </span>
          ),
          numeracaoReq: item.numeracaoReq,
          produtoDAF: item.produtoDAF.produtoFarmaceutico,
          valorUnitario: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorUnitario)}
            </span>
          ),
          cotacaoDolar: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.cotacaoDolar)}
            </span>
          ),
          qtdCotada: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarNumero(item.qtdCotada)}
            </span>
          ),
          valorTotal: (
            <span style={{ display: 'block', textAlign: 'right' }}>
              {formatarValorFormatoDinheiro(item.valorTotal)}
            </span>
          ),
        };
      }) || [];

  const offCanvasData =
    data?.map((item) => {
      return {
        id: item.id,
        dataRegistro:
          formatDate(item.dataRegistro) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
        dataUltimaAtualizacao:
          formatDate(item.dataUltimaAtualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
        dataUltimaVisualizacao:
          formatDate(item.dataUltimaVisualizacao) +
          ' - ' +
          formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
        nEdicoes: item.nEdicoes,
        nVisualizacoes: item.nVisualizacoes,
        separadorLog: '',
        produtoDAF: item.produtoDAF.produtoFarmaceutico,
        valorUnitario: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorUnitario)}
          </span>
        ),
        cotacaoDolar: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.cotacaoDolar)}
          </span>
        ),
        dataCotacao: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatDateSimp(item.dataCotacao)}
          </span>
        ),
        qtdCotada: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarNumero(item.qtdCotada)}
          </span>
        ),
        valorTotal: (
          <span style={{ display: 'block', textAlign: 'right' }}>
            {formatarValorFormatoDinheiro(item.valorTotal)}
          </span>
        ),

        separadorCotacao: '',
        observacoes: item.observacoes,
      };
    }) || [];

  //////FUNÇÕES HANDLE
  const handleClearForm = () => {
    setFormCotacao({
      id: 0,
      usuarioId: userID,
      orgInterId: orgInter,
      termoRefId: termoRefId,
      statusCotacao: 0,
      produtoId: 0,
      numeracaoReq: '',
      qtdCotada: '',
      cotacaoDolar: '',
      valorUnitario: '',
      valorTotal: '',
      dataSolicitacao: '',
      dataCotacao: '',
      observacoes: '',
    });
    setLogData({
      id: 0,
      usuarioRegistro: '',
      usuarioAtualizacao: '',
      dataRegistro: '',
      dataAtualizacao: '',
      nEdicoes: 0,
    });
  };

  const handleShowModal = () => setShowModal((prev) => !prev);

  const handleClickInserirNovo = () => {
    handleClearForm();
    setUpdatingCotacao(false);
    handleShowModal();
  };

  const handleRowClickCotacao = (id: string) => {
    setCotacaoId(id);
    setUpdatingCotacao(true);
    setShowModal(true);

    const itemSelecionado = data?.find((d) => d.id === id);
    if (itemSelecionado) {
      const dataSolicitacao = itemSelecionado.dataSolicitacao
        ? new Date(itemSelecionado.dataSolicitacao).toISOString().split('T')[0]
        : '';

      const dataCotacao = itemSelecionado.dataCotacao
        ? new Date(itemSelecionado.dataCotacao).toISOString().split('T')[0]
        : '';

      setFormCotacao({
        id: itemSelecionado.id,
        usuarioId: userID, // você já tem isso no escopo
        orgInterId: orgInter, // também está no escopo do componente
        termoRefId: termoRefId,
        produtoId: itemSelecionado.produtoDAF.id,
        statusCotacao: Number(itemSelecionado.statusCotacao),
        qtdCotada: formatarNumero(itemSelecionado.qtdCotada),
        numeracaoReq: itemSelecionado.numeracaoReq || '',
        valorUnitario: formatarValorFormatoDinheiro(
          itemSelecionado.valorUnitario,
        ),
        cotacaoDolar: formatarValorFormatoDinheiro(
          itemSelecionado.cotacaoDolar,
        ),
        valorTotal:
          formatarValorFormatoDinheiro(itemSelecionado.valorTotal) || '',
        dataSolicitacao: dataSolicitacao,
        dataCotacao: dataCotacao,
        observacoes: itemSelecionado.observacoes || '',
      });

      setLogData({
        id: itemSelecionado.id,
        usuarioRegistro: itemSelecionado.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          itemSelecionado.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: itemSelecionado.dataRegistro,
        dataAtualizacao: itemSelecionado.dataUltimaAtualizacao,
        nEdicoes: itemSelecionado.nEdicoes,
      });
    }
  };

  //////FUNÇÕES CRUD
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    let novoValor = value;

    const camposCalculo = ['cotacaoDolar', 'valorUnitario', 'qtdCotada'];

    if (camposCalculo.includes(name)) {
      // Formatar para exibição
      if (name === 'qtdCotada') {
        novoValor = formatarNumero(value);
      } else {
        novoValor = formatoMoney(value, 2);
      }

      const cotacao =
        name === 'cotacaoDolar'
          ? parseInputMonetario(value)
          : parseInputMonetario(formCotacao.cotacaoDolar?.toString() || '0');

      const unitario =
        name === 'valorUnitario'
          ? parseInputMonetario(value)
          : parseInputMonetario(formCotacao.valorUnitario?.toString() || '0');

      const qtdCotada =
        name === 'qtdCotada'
          ? parseFloat(value.replace(/\./g, '')) || 0
          : parseFloat(
              formCotacao.qtdCotada?.toString().replace(/\./g, '') || '0',
            );
      const totalReais = cotacao * unitario * qtdCotada;
      console.log(totalReais);
      const totalFormatado = formatarValorFormatoDinheiro(totalReais);

      setFormCotacao((prev: CotacaoType) => ({
        ...prev,
        [name]: novoValor,
        valorTotal: totalFormatado,
      }));
      return;
    }

    setFormCotacao((prev: CotacaoType) => ({
      ...prev,
      [name]: novoValor,
    }));
  };

  const adjustFormCotacaoBeforeSubmit = (formCotacao: any) => {
    const adjustedForm = {
      ...formCotacao,
      orgInterId: Number(formCotacao.orgInterId),
      termoRefId: Number(formCotacao.termoRefId),
      produtoId: Number(formCotacao.produtoId),
      numeracaoReq: formCotacao.numeracaoReq.trim(),
      statusCotacao: Number(formCotacao.statusCotacao),
      qtdCotada: Number(formCotacao.qtdCotada.replace(/\./g, '')),
      cotacaoDolar: Number(
        formCotacao.cotacaoDolar.replace(/\./g, '').replace(',', '.'),
      ),
      valorUnitario: Number(
        formCotacao.valorUnitario.replace(/\./g, '').replace(',', '.'),
      ),

      //Observações
      observacoes:
        formCotacao.observacoes === ''
          ? 'Sem observações específicas.'
          : formCotacao.observacoes,
    };

    // Remover campos não desejados
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { valorTotal, ...cleanForm } = adjustedForm;

    return cleanForm;
  };

  const validateForm = (form: any) => {
    const erros = [];

    if (form.statusCotacao === 0)
      erros.push('<b>Status da Cotação</b> é obrigatório.');
    if (form.numeracaoReq === '') erros.push('<b>Nº da REQ</b> é obrigatório.');
    if (form.statusCotacao > 1) {
      if (!form.dataCotacao)
        erros.push('<b>Data de Cotação</b> é obrigatório.');
    }
    if (!form.dataSolicitacao)
      erros.push('<b>Data de Solicitação</b> é obrigatório.');

    if (form.produtoId === 0)
      erros.push('<b>Produto Farmacêutico</b> é obrigatório.');
    if (!form.qtdCotada) erros.push('<b>Quantidade Cotada</b> é obrigatório.');
    if (!form.cotacaoDolar)
      erros.push('<b>Cotação do Dólar</b> é obrigatório.');
    if (!form.valorUnitario) erros.push('<b>Valor Unitário</b> é obrigatório.');

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  };

  const handleCreate = async () => {
    try {
      if (!validateForm(formCotacao)) throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormCotacaoBeforeSubmit(formCotacao);
      await httpClient.post(`/api/orginter-cotacao`, adjustedForm);
      swalSave();
      fetchCotacoes();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao salvar registro:', err);
    }
  };

  const handleUpdate = async () => {
    try {
      if (!validateForm(formCotacao)) throw new Error('Formulário inválido.');

      // Ajustar o formulário antes de enviar para o backend
      const adjustedForm = adjustFormCotacaoBeforeSubmit(formCotacao);

      const response = await httpClient.patch(
        `/api/orginter-cotacao/${cotacaoId}`,
        adjustedForm,
      );
      swalAtualizacao('Sucesso', response.data.message);
      fetchCotacoes();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao atualizar registro:', err);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) return swalErro('A operação falhou.');
    try {
      await httpClient.delete(`/api/orginter-cotacao/${cotacaoId}`);
      swalDeleteConfirm();
      fetchCotacoes();
      setTimeout(() => handleShowModal(), 2000);
    } catch (err: any) {
      if (isHttpError(err)) swalErro(err.response?.data.message);
      console.error('Erro ao excluir registro:', err);
    }
  };

  //USE EFFECT
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const laranja = '#faca71dd';
    const amarelo = '#faffb4dd';

    const status = String(formCotacao.statusCotacao);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? laranja
              : status === '4'
                ? vermelho
                : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formCotacao.statusCotacao]);

  return (
    <BoxConteudo boxTitulo="Cotação (REQ)">
      <CustomRow>
        <CustomCol width="100%">
          <Tabela
            headers={headersCotacao}
            dataTable={tableData}
            displayValues={valoresExibidosCotacao}
            onRowClick={handleRowClickCotacao}
            dataOffCanvas={offCanvasData}
            botaoAbrirOffCanvas={false}
            showPagination={false}
            noOffCanvasTable={true}
          />
        </CustomCol>
      </CustomRow>
      <CustomCol className="d-flex justify-content-end">
        <CustomButton
          label="Novo Registro"
          bgColor={theme.colors.botaoAcao.azul}
          textColor={theme.colors.white}
          onClick={() => {
            setUpdatingCotacao(false);
            handleClickInserirNovo();
          }}
        />
      </CustomCol>

      {/* Modal Fiscal /*/}
      <Modal
        tituloModal="Cotação de Produto Farmacêutico (REQ)"
        open={showModal}
        onHide={handleShowModal}
        style={{ width: '100vw' }}
      >
        <WorkspaceFicha>
          <Log
            {...logData}
            entity="TB_ORG_INTER_COTACAO"
            id={Number(formCotacao.id)}
          />
          <BoxConteudo boxTitulo="Item">
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol
                width="100px"
                helpText="ID do Termo de Referência (TR)"
              >
                <Input
                  id="termoRefId"
                  name="termoRefId"
                  label="ID do TR"
                  value={formCotacao.termoRefId}
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol width="250px">
                <Select
                  name="statusCotacao"
                  options={statusCotacaoOptions}
                  label="Status"
                  value={formCotacao.statusCotacao}
                  onChange={handleChange}
                  style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="180px">
                <Input
                  id="numeracaoReq"
                  name="numeracaoReq"
                  value={formCotacao.numeracaoReq}
                  label="Nº da REQ"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol
                width="180px"
                helpText="Data em que o produto foi solicitado à cotação."
              >
                <Input
                  id="dataSolicitacao"
                  name="dataSolicitacao"
                  type="date"
                  value={formCotacao.dataSolicitacao}
                  label="Data da Solicitação"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol
                width="180px"
                helpText="Data em que o parceiro internacional enviou a cotação do produto."
              >
                <Input
                  id="dataCotacao"
                  name="dataCotacao"
                  type="date"
                  value={formCotacao.dataCotacao}
                  label="Data da Cotação"
                  onChange={handleChange}
                  required={formCotacao.statusCotacao > 1}
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="100px" helpText="ID do Produto Farmacêutico">
                <Input
                  id="produtoId"
                  name="produtoId"
                  value={
                    formCotacao.produtoId === 0 ? '' : formCotacao.produtoId
                  }
                  label="ID"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Select
                  name="produtoId"
                  value={formCotacao.produtoId}
                  label="Produto Farmacêutico"
                  options={produtoData}
                  onChange={handleChange}
                  required
                  disabled={updatingCotacao}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="200px">
                <Input
                  id="qtdCotada"
                  name="qtdCotada"
                  value={formCotacao.qtdCotada}
                  label="Quantidade Cotada"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="170px">
                <Input
                  id="valorUnitario"
                  name="valorUnitario"
                  value={formCotacao.valorUnitario}
                  label="Valor Unitário (US$)"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>
              <CustomCol width="170px">
                <Input
                  id="cotacaoDolar"
                  name="cotacaoDolar"
                  value={formCotacao.cotacaoDolar}
                  label="Câmbio R$/US$"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  required
                />
              </CustomCol>

              <CustomCol width="220px">
                <Input
                  id="valorTotal"
                  name="valorTotal"
                  value={formCotacao.valorTotal}
                  label="Valor Total R$"
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol>
              <CustomCol></CustomCol>
            </CustomRow>

            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formCotacao.observacoes}
                  label="Observações"
                  linhas={5}
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
          <BarraInferiorBotoes>
            {updatingCotacao ? (
              <WorkspaceBotoes
                delete
                // deleteDisabled={btDisable}
                onClickDelete={handleDelete}
                save
                // saveDisabled={btDisable}
                onClickSave={handleUpdate}
              />
            ) : (
              <WorkspaceBotoes
                inserir
                // inserirDisabled={btDisable}
                onClickInserir={handleCreate}
              />
            )}
          </BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </BoxConteudo>
  );
};

export default ItemCotacao;
